
    const data = {"name":"src/core/icons/information-box-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 9h-2V7h2v2m0 8h-2v-6h2v6M5 3h14a2 2 0 0 1 2 2v14c0 .53-.21 1.04-.59 1.41-.37.38-.88.59-1.41.59H5c-.53 0-1.04-.21-1.41-.59C3.21 20.04 3 19.53 3 19V5c0-1.11.89-2 2-2m14 16V5H5v14h14Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            